import { render } from "./StockBoundTabs.vue?vue&type=template&id=3ce6a2a5&scoped=true"
import script from "./StockBoundTabs.vue?vue&type=script&lang=js"
export * from "./StockBoundTabs.vue?vue&type=script&lang=js"

import "./StockBoundTabs.vue?vue&type=style&index=0&id=3ce6a2a5&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce6a2a5"]])

export default __exports__